export const toggleSelection = (selectionItem: number, selection: number[]) => {
  if (selection.includes(selectionItem)) {
    return selection.filter((item) => item !== selectionItem);
  }
  return [...selection, selectionItem];
};
